import { render, staticRenderFns } from "./ServersList.vue?vue&type=template&id=c9280ee0&scoped=true"
import script from "./ServersList.vue?vue&type=script&lang=js"
export * from "./ServersList.vue?vue&type=script&lang=js"
import style0 from "./ServersList.vue?vue&type=style&index=0&id=c9280ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9280ee0",
  null
  
)

export default component.exports